// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_AdditionalServiceFiscalRemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/additional_service_fiscal/remover
 *
 * Returns null dados on success.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type So_AdditionalServiceFiscalRemoverResponseDados = null;

export type So_AdditionalServiceFiscalRemoverResponse = ApiResponse<So_AdditionalServiceFiscalRemoverResponseDados>;

registerResponseContract('So_AdditionalServiceFiscalRemoverResponse', {})
